var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "path-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667383,0.5 C18.0436423,0.5 19.1667383,1.62309604 19.1667383,3 L19.1667383,13 C19.1667383,14.376904 18.0436423,15.5 16.6667383,15.5 L3.333405,15.5 C1.95650104,15.5 0.833405,14.376904 0.833405,13 L0.833405,3 C0.833405,1.62309604 1.95650104,0.5 3.333405,0.5 L16.6667383,0.5 Z M17.499405,4.6 L10.4779569,9.5160266 C10.1910235,9.71688002 9.80911984,9.71688002 9.52218638,9.5160266 L2.499405,4.6 L2.50007167,13 C2.50007167,13.4564294 2.87697562,13.8333333 3.333405,13.8333333 L16.6667383,13.8333333 C17.1231677,13.8333333 17.5000717,13.4564294 17.5000717,13 L17.499405,4.6 Z M16.6667383,2.16666667 L3.333405,2.16666667 C3.00969896,2.16666667 2.72599296,2.35624344 2.58836888,2.62931509 L10.0000717,7.81612037 L17.4112817,2.62833903 C17.273474,2.3557918 16.9900586,2.16666667 16.6667383,2.16666667 Z",
    id: "path-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cb27644636446dc7d13f37eccf3f59b8.svg";
export { ForwardRef as ReactComponent };